import React, {useContext} from "react"
import {PanelExpandedSection} from "uiKit/PanelExpandedSection"
import {ActiveStudentContext} from "context/ActiveStudentContext"
import {useQuery} from "@tanstack/react-query"
import {userPersonalContactsServiceV3} from "services"
import {ContactCard} from "sections/users/Detail/parts/Contacts/parts"
import styles from "./StudentPersonalContacts.module.css"
import {UserProfileType} from "@edular/permissions"
import {UserContactType} from "types/contacts"

type Props = {
    onClose?: () => void
}

export function StudentPersonalContacts(props: Props) {
    const {onClose} = props
    const {student, departmentId} = useContext(ActiveStudentContext)

    const {data: contacts} = useQuery({
        queryKey: ["student-personal-contacts", student.userId],
        queryFn: async () => {
            const {data} = await userPersonalContactsServiceV3.getByUser(student.userId)
            return data
        },
        enabled: !!student.userId,
        initialData: []
    })

    return (
        <PanelExpandedSection title="Personal Contacts" onClose={onClose}>
            <div className={styles.contactsList}>
                {contacts.map((contact) => {
                    return (
                        <ContactCard
                            key={contact.id}
                            data={contact}
                            type={UserContactType.personal}
                            userId={student.userId}
                            profileType={UserProfileType.Student}
                            showMenu={false}
                            departmentId={departmentId}
                        />
                    )
                })}
            </div>
        </PanelExpandedSection>
    )
}
